/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hamburger'
export default icon
